import { writable } from 'svelte/store';

import { ERROR_MAP } from '../constants/common';
import { CURRENCY_UNIT, JUMP_TYPE_ENUM } from '../enums';

export const GroupType = {
    A: 'group_a',
    B: 'group_b',
    C: 'group_c',
    D: 'group_d',
    E: 'group_e',
    F: 'group_f'
};
export const startTime = writable(''); // 开始时间戳
export const groupType = writable(GroupType.A); // 页面区分
export const isCookiesShow = writable(''); // 是否展示cookie
export const errorType = writable(ERROR_MAP.HOME); // 错误类型
export const isLogin = writable(false); // 是否登录
export const PhoneCell = writable(''); // 登陆
export const rewardAmountUnit = writable(CURRENCY_UNIT); // 奖励金额单位
export const jumpType = writable(JUMP_TYPE_ENUM.TO_WEB2APP); // 跳转类型
export const visible = writable(true);
export const isJumpOneLInk = writable(false); // 是否跳转OneLink
export const userID = writable('');
export const omegaParams = writable({}); // 埋点公参
export const cookieHeight = writable(0); // cookie高度

export const isShowBtn = writable(false);
export const isShowBtn1 = writable(false);
export const isLoadingForFloatBtn = writable(false);
export const openPolicy = writable(false);
export const uiType = writable('A');
